/**
 * API client de Atendimento (CRM, Fase 3 turno 4) — usado no Bloco B
 * para listar atendimentos vinculados a um orcamento.
 *
 *   GET    /api/comercial/atendimentos                 list (filtros)
 *   POST   /api/comercial/atendimentos
 *   GET    /api/comercial/atendimentos/{id}
 *   PATCH  /api/comercial/atendimentos/{id}
 *   DELETE /api/comercial/atendimentos/{id}            (MFA)
 *
 * Filtros: ?cliente, ?cliente_final, ?orcamento, ?tipo, ?canal,
 *          ?resultado, ?responsavel, ?data_de, ?data_ate.
 */

const PREFIXO = "/api/comercial/atendimentos";

export function listarAtendimentos(request, params = {}) {
  const usp = new URLSearchParams();
  if (params.cliente) usp.set("cliente", params.cliente);
  if (params.cliente_final) usp.set("cliente_final", params.cliente_final);
  if (params.orcamento) usp.set("orcamento", params.orcamento);
  if (params.tipo) usp.set("tipo", params.tipo);
  if (params.canal) usp.set("canal", params.canal);
  if (params.resultado) usp.set("resultado", params.resultado);
  if (params.responsavel) usp.set("responsavel", params.responsavel);
  if (params.data_de) usp.set("data_de", params.data_de);
  if (params.data_ate) usp.set("data_ate", params.data_ate);
  if (params.page) usp.set("page", params.page);
  if (params.pageSize) usp.set("page_size", params.pageSize);
  const qs = usp.toString();
  return request(`${PREFIXO}${qs ? `?${qs}` : ""}`);
}

export function criarAtendimento(request, dados) {
  return request(PREFIXO, {
    method: "POST",
    body: JSON.stringify(dados),
  });
}

export function atualizarAtendimento(request, id, dados) {
  return request(`${PREFIXO}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(dados),
  });
}
